import React, { useState, useEffect } from 'react';
import { useAtaCodes } from "../../../providers/AtaCodeProvider";
import { useToast } from "../../../providers/ToastProvider";
import { NOTIFICATION_TYPES } from "../../ToastNotification/toastConstants";

interface ATACodeInputProps {
  onATACodeChange: (code: string,description:string, isValid: boolean) => void;
}

const ATACodeInput: React.FC<ATACodeInputProps> = ({ onATACodeChange }) => {
  const [ataCode, setSelectedATACode] = useState("");
  const [ataCodeDescription, setATACodeDescription] = useState("");
  const [isATAValid, setIsATAValid] = useState(false);
  const [ATAError, setATAError] = useState(false);
  const { ataCodes, isAtaCodeHttpError } = useAtaCodes();
  const { addToast} = useToast();

    useEffect(() => {
      if (isAtaCodeHttpError) {
        addToast(NOTIFICATION_TYPES.WARNING, 'Unable to retrieve ATA codes.', 'Please try again.');
      }
    }, [isAtaCodeHttpError]);
  

  const handleATAcode = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;
    if ((key >= '0' && key <= '9') || key === 'Backspace' || key === 'Tab' || key === 'ArrowLeft' || key === 'ArrowRight') {
      const atacode = (event.target as HTMLInputElement).value;
      setSelectedATACode(atacode);
      validateATACode(atacode, event);
    } else {
      event.preventDefault();
    }
  };

  const handleATaonBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    validateATACode(ataCode, event);
  };

  const validateATACode = (code: string, event: any) => {
    const result = Array.isArray(ataCodes) ? ataCodes.map((e) => e.ChapterCode).includes(code) : null;
    let isValid = false;

    if (code.length === 0) {
      setIsATAValid(false);
      setATAError(true);
    } else if (!result || (code.length < 2 && code.length > 0)) {
      event.target.validity = "customError";
      event.target.isValid = false;
      setATACodeDescription("");
      setIsATAValid(false);
      setATAError(true);
    } else {
      const atadescription = Array.isArray(ataCodes) ? ataCodes.find((e) => e.ChapterCode === code)?.Description || "" : "";
      setIsATAValid(true);
      setATAError(false);
      setATACodeDescription(atadescription);
      isValid = true;
    }

    onATACodeChange(code, ataCodeDescription, isValid,);
  };

  return (
    <div className="ots-fleet-dropdown-placeholder">
      <auro-input
        data-testid="ata-code"
        required
        validateOnInput
        bordered
        maxLength="2"
        setCustomValidity=" "
        value={ataCode}
        onKeyUp={handleATAcode}
        onKeyDown={handleATAcode}
        onBlur={handleATaonBlur}
      >
        <span slot="label">ATA</span>
      </auro-input>
      {ataCode === "" && ATAError && <div className="dateTimeError">Please fill out this field</div>}
      {ataCode !== "" && ATAError && <div className="dateTimeError">Enter a valid ATA</div>}
    </div>
  );
};

export default ATACodeInput;